import React from 'react';
import { motion } from 'framer-motion';
import { Lock } from 'lucide-react';
export function PricingCTA() {
  return <section className="py-16 relative overflow-hidden pt-[10px] pb-[10px]" data-id="element-126">
      {/* Intense bottom glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-brand-gold/10 blur-[150px] rounded-full pointer-events-none" data-id="element-127" />

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-128">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-129">
          <span className="inline-block py-1 px-3 rounded-full bg-brand-gold/10 text-brand-gold text-sm font-bold tracking-widest uppercase mb-4 border border-brand-gold/20" data-id="element-130">
            Precio Especial de Lanzamiento
          </span>

          <h2 className="text-4xl md:text-5xl font-black text-brand-white mb-4" data-id="element-131">
            Recupera tu paz mental por solo:
          </h2>

          <div className="flex flex-col items-center justify-center mb-6" data-id="element-132">
            <span className="text-2xl md:text-3xl font-bold text-brand-gray line-through mb-1 opacity-70" data-id="element-133">
              $19.99
            </span>
            <div className="flex items-center justify-center gap-2" data-id="element-134">
              <span className="text-6xl md:text-8xl font-black text-brand-gold text-glow-gold tracking-tighter" data-id="element-135">
                $6.39
              </span>
              <span className="text-2xl text-brand-gray font-medium mt-4" data-id="element-136">
                USD
              </span>
            </div>
          </div>

          <motion.a href="https://pay.hotmart.com/J105067242R" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full md:w-auto px-8 py-5 text-brand-black font-black text-lg md:text-xl rounded-xl uppercase tracking-wide shadow-[0_0_40px_rgba(201,168,76,0.4)] hover:shadow-[0_0_60px_rgba(201,168,76,0.6)] transition-all duration-300 mb-4 flex items-center justify-center gap-3 mx-auto bg-[#FF0000]" data-id="element-137">
            Quiero recuperar mi paz mental ahora
          </motion.a>

          <div className="flex flex-col items-center justify-center gap-2 text-brand-gray text-sm" data-id="element-138">
            <div className="flex items-center gap-2" data-id="element-139">
              <Lock className="w-4 h-4" data-id="element-140" />
              <span data-id="element-141">Pago 100% seguro y encriptado</span>
            </div>
            <p data-id="element-142">
              Acceso instantáneo. Formato PDF compatible con todos los
              dispositivos.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}